import { render } from "./CreateMaterialFromInv.vue?vue&type=template&id=1c5276cc&scoped=true"
import script from "./CreateMaterialFromInv.vue?vue&type=script&lang=js"
export * from "./CreateMaterialFromInv.vue?vue&type=script&lang=js"

import "./CreateMaterialFromInv.vue?vue&type=style&index=0&id=1c5276cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5276cc"]])

export default __exports__